<p>payment-page-table works!</p>
